module.exports = __webpack_public_path__ + "img/carmo.c22f9339.jpg";